import React, { useEffect, useState } from 'react'

import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import CValidator from '../CValidator';
import { Col, Form, Row } from "react-bootstrap"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import CTextBox from '../CTextBox';
import { t } from 'i18next';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../common/Helpers';
import { TextField } from '@fluentui/react';
import './style.css'

function CTextAreaWithPlaceHolders(props) {

    //Parametros de entrada.
    const inputParam_LabelText = props.labelText;
    const inputParam_ControlValue = props.controlValue !== null && props.controlValue !== undefined ? props.controlValue : "";
    const inputParam_ClassName = props.className !== null && props.className !== undefined ? props.className : "";
    const inputParam_SetterControlValue = props.setterControlValue;
    const inputParam_IsInvalirControl = props.isInvalirControl;
    const inputParam_MaxLength = props.maxLength !== null && props.maxLength !== undefined ? props.maxLength : null;
    const inputParam_ReadOnly = props.readOnly !== null && props.readOnly !== undefined ? props.readOnly : false;
    const inputParam_EntityId = props.entityId !== null && props.entityId !== undefined ? props.entityId : null;
    const inputParam_Template = props.template !== null && props.template !== undefined ? props.template : null;
    const inputParam_PlaceHolders = props.placeHolders !== null && props.placeHolders !== undefined ? props.placeHolders : [];
    


    //Parametros de componente.
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(inputParam_ControlValue))));
    const [isInvalidControl, setIsInvalidControl] = useState(false);
    const [placeholders, setPlaceholders] = useState(inputParam_PlaceHolders);
    const [currentTemplate, setCurrentTemplate] = useState(inputParam_Template);
    
    //Funciones de componente.
    const isInValidFormControl = (value) => {
        return value === "" ? true : false;
    }

    const checkIfIsInvalidControl = () => {
        const _isInvalidControl = isInvalidControl !== null ? isInvalidControl : false;
        const _inputParam_IsInvalirControl = inputParam_IsInvalirControl !== null ? inputParam_IsInvalirControl : false;

        return _isInvalidControl === true | _inputParam_IsInvalirControl === true ? true : false;
    }

    //Eventos de componente.
    const onChangeValue = (controlState) => {

        const controlValue = draftToHtml(convertToRaw(controlState.getCurrentContent()))

        setEditorState(controlState);
        setIsInvalidControl(isInValidFormControl(controlValue !== null && controlValue !== ""));
        inputParam_SetterControlValue(controlValue);
    };

    const handleBeforeInput = (input) => {
        if (inputParam_MaxLength !== null) {
            const currentContent = editorState.getCurrentContent();
            const currentLength = currentContent.getPlainText('').length;
        
            if (currentLength >= inputParam_MaxLength) {
                return 'handled';
            }
            return 'not-handled';
        }
        else {
            return 'not-handled';
        }
    };
    
    const handlePastedText = (pastedText, html) => {
        if (inputParam_MaxLength !== null) {
            const currentContent = editorState.getCurrentContent();
            const currentLength = currentContent.getPlainText('').length;
        
            if (currentLength + pastedText.length > inputParam_MaxLength) {
                return true;
            }
            return false;
        }
        else {
            return false;
        }
    };

    /* Función que recibe el template y el listado de placeholders y reemplaza cada {placeholder} por el valor correspondiente. */
    const generateTextFromTemplate = (text, placeholdersList) => {
        let updatedText = text;
        placeholdersList.forEach((item) => {
            const regex = new RegExp(`{${item.name}}`, 'g');
            updatedText = updatedText.replace(regex, `{${item.value}}`);
        });

        inputParam_SetterControlValue && inputParam_SetterControlValue(updatedText)

        return updatedText;
    };

    /* Cada vez que cambien los valores de `placeholders`, recalculamos el texto y actualizamos el estado del editor de solo lectura. */
    useEffect(() => {
        if (!isNullUndefined(inputParam_Template)) {
            const newText = generateTextFromTemplate(inputParam_Template, inputParam_Template === currentTemplate ? placeholders : inputParam_PlaceHolders);
            const newContent = ContentState.createFromText(newText);
            setEditorState(EditorState.createWithContent(newContent));
            setPlaceholders(inputParam_Template === currentTemplate ? placeholders : inputParam_PlaceHolders)

            if (currentTemplate !== inputParam_Template) {
                setCurrentTemplate(inputParam_Template)
            }
        }
    }, [inputParam_PlaceHolders, placeholders]);

    /* Maneja el cambio en cada TextField, actualizando el `value` correspondiente en el arreglo de placeholders. */
    const handlePlaceholderChange = (id, newValue) => {
        setPlaceholders((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, value: newValue } : item
            )
        );
    };







    //Render de componente.
    return (
        <>
        {
            inputParam_ReadOnly !== true &&
            <>
                {
                    !isNullUndefinedOrEmpty(inputParam_LabelText) &&
                    <b><Form.Label className="pe-2">{ inputParam_LabelText }:</Form.Label></b>
                }
                <Row>
                    <Col>
                        {
                            placeholders.map((placeholder) => (
                                <TextField
                                    key={placeholder.id}
                                    label={placeholder.name}
                                    value={placeholder.value}
                                    onChange={(_, newValue) =>
                                        handlePlaceholderChange(placeholder.id, newValue)
                                    }
                                />
                            ))
                        }
                    </Col>
                </Row>
                <Row className='pt-5'>
                    <Col xl={12}>
                        <b><Form.Label className="pe-2">{ t('data-lang-lbl-bodytemplate') }:</Form.Label></b>
                    </Col>
                    <Col xl={12}>
                        {
                            inputParam_MaxLength !== null &&
                            <Editor
                                editorState={ editorState }
                                wrapperClassName={"demo-wrapper " + inputParam_ClassName}
                                editorClassName="demo-editor-template"
                                onEditorStateChange={ onChangeValue }
                                value={inputParam_ControlValue}
                                toolbarHidden={true}
                                handlePastedText={handlePastedText}
                                handleBeforeInput={handleBeforeInput}
                            />
                        }
                        {
                            inputParam_MaxLength === null &&
                            <Editor
                                editorState={ editorState }
                                wrapperClassName={"demo-wrapper " + inputParam_ClassName}
                                editorClassName="demo-editor-template"
                                onEditorStateChange={ onChangeValue }
                                value={inputParam_ControlValue}
                                toolbarHidden={true}
                            />
                        }
                        <CValidator isInValid={ checkIfIsInvalidControl() } />
                    </Col>
                </Row>
            </>
        }
        {
            inputParam_ReadOnly === true &&
            <Editor
                editorState={ editorState }
                toolbarHidden
                readOnly
            />
        }
        </>
    );
}

export default CTextAreaWithPlaceHolders;